// Gói G trên trang Cài đặt: (1) Thông báo — Telegram (mã khoá bot, mã chat, ngưỡng ngoại tuyến), SMTP tuỳ chọn, nút Gửi thử;
// (2) Lịch phát lệnh — nay ở pages/lich-chay.ts (thẻ dùng chung cho trang Lịch chạy + Cài đặt).
// Hợp đồng: docs/boss-api.md mục "Thông báo & lịch (gói G)". Mã khoá/mật khẩu chỉ hiện dạng che (…abcd / ••••) và gửi lại y nguyên = giữ cũ.
import { api, errMsg } from "../api";
import { busy, h, toast } from "../dom";
import type { JobSpec } from "../types";

export interface SmtpConfig { host: string; port: number; user?: string; pass?: string; from: string; to: string }
export interface NotifyConfig { telegramToken: string; telegramChat: string; smtp: SmtpConfig | null; offlineMin: number }
// thu = thứ chạy (1 = Thứ hai … 7 = Chủ nhật; mặc định cả tuần), lech = độ lệch ngẫu nhiên 0–60 phút, goiDungId = lịch này thuộc một Gói seeding,
// gioHomNay = giờ chạy thực tế hôm nay (hhmm + lệch xác định) hoặc null (docs/thiet-ke-goi-seeding.md).
export interface Schedule { id: string; ownerId: string; hhmm: string; tz: string; template: JobSpec; enabled: boolean; lastRunDate: string | null; lastJobId?: string | null; thu?: number[]; lech?: number; goiDungId?: string | null; gioHomNay?: string | null }

const TEN_THU = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];
const TEN_THU_DAY = ["Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy", "Chủ nhật"];
const CA_TUAN = [1, 2, 3, 4, 5, 6, 7];
/** [1..7] → "mỗi ngày" hoặc "T2 T4 CN". */
export function thuText(thu: number[] | undefined): string {
  const t = (thu && thu.length ? [...thu] : CA_TUAN).sort((a, b) => a - b);
  return t.length === 7 ? "mỗi ngày" : t.map((x) => TEN_THU[x - 1]).join(" ");
}

// ---------------- Thông báo ----------------
export function renderNotifyCard(root: HTMLElement): void {
  const token = h("input", { type: "password", autocomplete: "off", placeholder: "123456789:AAF… (từ @BotFather)", title: "Mã khoá (token) bot Telegram lấy từ @BotFather; để nguyên chuỗi che = giữ mã cũ", "data-testid": "tg-token" });
  const chat = h("input", { placeholder: "mã chat (số) hoặc @kênh", title: "Nơi nhận tin: mã chat dạng số hoặc tên kênh bắt đầu bằng @; bot Telegram phải có quyền gửi vào đó", "data-testid": "tg-chat" });
  const offlineMin = h("input", { type: "number", min: 1, max: 1440, step: 1, value: "10", title: "Bot ngoại tuyến liên tục quá số phút này thì gửi cảnh báo (1–1440)", "data-testid": "offline-min" });
  const smtpOn = h("input", { type: "checkbox", title: "Bật để gửi thêm thông báo qua Email (SMTP) ngoài Telegram", "data-testid": "smtp-on" });
  const smtpHost = h("input", { placeholder: "smtp.gmail.com", title: "Địa chỉ máy chủ SMTP của nhà cung cấp email", "data-testid": "smtp-host" });
  const smtpPort = h("input", { type: "number", min: 1, max: 65535, value: "587", title: "Cổng SMTP: 465 = TLS, 587 = STARTTLS", "data-testid": "smtp-port" });
  const smtpUser = h("input", { placeholder: "tài khoản (tuỳ chọn)", autocomplete: "off", title: "Tài khoản đăng nhập SMTP, để trống nếu máy chủ không cần", "data-testid": "smtp-user" });
  const smtpPass = h("input", { type: "password", placeholder: "mật khẩu (tuỳ chọn)", autocomplete: "new-password", title: "Mật khẩu hoặc mật khẩu ứng dụng SMTP; để nguyên chuỗi che = giữ mật khẩu cũ", "data-testid": "smtp-pass" });
  const smtpFrom = h("input", { placeholder: "boss@congty.vn", title: "Địa chỉ email hiện ở mục người gửi", "data-testid": "smtp-from" });
  const smtpTo = h("input", { placeholder: "sep@congty.vn", title: "Địa chỉ email nhận thông báo", "data-testid": "smtp-to" });
  const smtpBox = h("div", { class: "field-row", hidden: true, "data-testid": "smtp-box" },
    h("label", { class: "f" }, h("span", {}, "Máy chủ SMTP"), smtpHost),
    h("label", { class: "f" }, h("span", {}, "Cổng (465 = TLS, 587 = STARTTLS)"), smtpPort),
    h("label", { class: "f" }, h("span", {}, "Tài khoản"), smtpUser),
    h("label", { class: "f" }, h("span", {}, "Mật khẩu"), smtpPass),
    h("label", { class: "f" }, h("span", {}, "Gửi từ địa chỉ"), smtpFrom),
    h("label", { class: "f" }, h("span", {}, "Gửi tới địa chỉ"), smtpTo));
  smtpOn.addEventListener("change", () => { smtpBox.hidden = !smtpOn.checked; });
  const tokenLabel = h("span", {}, "Mã khoá bot Telegram (token)");
  const status = h("p", { class: "small muted", "data-testid": "notify-status" }, "Đang tải…");
  const result = h("div", { class: "small", hidden: true, "data-testid": "notify-result" });
  const save = h("button", { type: "button", class: "pri", title: "Lưu cấu hình Telegram/Email; áp dụng ngay cho các thông báo sau", "data-testid": "notify-save" }, "Lưu");
  const test = h("button", { type: "button", title: "Gửi một tin thử qua các kênh ĐÃ LƯU để kiểm cấu hình có nhận được không", "data-testid": "notify-test" }, "Gửi thử");

  function fill(c: NotifyConfig): void {
    token.value = c.telegramToken;
    tokenLabel.textContent = c.telegramToken ? `Mã khoá bot Telegram (token) — đang lưu ${c.telegramToken} — để nguyên = giữ` : "Mã khoá bot Telegram (token)";
    chat.value = c.telegramChat;
    offlineMin.value = String(c.offlineMin);
    smtpOn.checked = !!c.smtp;
    smtpBox.hidden = !c.smtp;
    smtpHost.value = c.smtp?.host ?? "";
    smtpPort.value = String(c.smtp?.port ?? 587);
    smtpUser.value = c.smtp?.user ?? "";
    smtpPass.value = c.smtp?.pass ?? "";
    smtpFrom.value = c.smtp?.from ?? "";
    smtpTo.value = c.smtp?.to ?? "";
    const on: string[] = [];
    if (c.telegramToken && c.telegramChat) on.push("Telegram");
    if (c.smtp) on.push("Email");
    status.textContent = on.length ? `Đang bật: ${on.join(" + ")} · báo khi bot ngoại tuyến quá ${c.offlineMin} phút, lần chạy lỗi, chờ duyệt, bot chạy trước (canary) hỏi, hết hạn mức, DỪNG TẤT CẢ. Gộp tin trong 60 s.` : "Chưa cấu hình kênh nào — nhập mã khoá bot Telegram (hoặc Email SMTP) rồi Lưu.";
  }
  function showResult(text: string, ok: boolean): void {
    result.hidden = false;
    result.className = ok ? "small ok" : "small err";
    result.textContent = text;
  }
  function localErrors(): string[] {
    const errs: string[] = [];
    const n = Number(offlineMin.value);
    if (!offlineMin.value.trim() || !Number.isInteger(n) || n < 1 || n > 1440) errs.push("Ngưỡng ngoại tuyến phải là số nguyên 1–1440 phút");
    const c = chat.value.trim();
    if (c && !/^-?\d+$/.test(c) && !/^@[A-Za-z0-9_]{3,}$/.test(c)) errs.push("Mã chat phải là số hoặc @kênh");
    if (token.value.trim() && !chat.value.trim()) errs.push("Có mã khoá bot thì cần mã chat");
    if (smtpOn.checked) {
      if (!smtpHost.value.trim()) errs.push("SMTP: thiếu máy chủ");
      const p = Number(smtpPort.value);
      if (!Number.isInteger(p) || p < 1 || p > 65535) errs.push("SMTP: cổng 1–65535");
      if (!smtpFrom.value.trim() || !smtpTo.value.trim()) errs.push("SMTP: cần địa chỉ gửi và nhận");
    }
    return errs;
  }
  function body(): Record<string, unknown> {
    return {
      telegramToken: token.value.trim(),
      telegramChat: chat.value.trim(),
      offlineMin: Number(offlineMin.value),
      smtp: smtpOn.checked
        ? { host: smtpHost.value.trim(), port: Number(smtpPort.value), user: smtpUser.value.trim(), pass: smtpPass.value, from: smtpFrom.value.trim(), to: smtpTo.value.trim() }
        : null,
    };
  }
  save.addEventListener("click", () => void busy(save, "Đang lưu…", async () => {
    const errs = localErrors();
    if (errs.length) { showResult(errs.join(" · "), false); return; }
    try {
      const c = await api<NotifyConfig>("PUT", "/api/notify", body());
      fill(c);
      showResult("Đã lưu cấu hình thông báo", true);
      toast("Đã lưu cấu hình thông báo");
    } catch (e) { showResult(errMsg(e), false); }
  }));
  test.addEventListener("click", () => void busy(test, "Đang gửi…", async () => {
    try {
      await api<{ sent: boolean }>("POST", "/api/notify/test");
      showResult("Đã gửi \"Boss: thử thông báo\" — kiểm tra Telegram/email của bạn.", true);
    } catch (e) { showResult(`Gửi thử thất bại: ${errMsg(e)}`, false); }
  }));

  root.append(h("div", { class: "card", "data-testid": "notify-card" },
    h("h3", {}, "Thông báo (Telegram / Email)"),
    status,
    h("div", { class: "field-row" },
      h("label", { class: "f" }, tokenLabel, token),
      h("label", { class: "f" }, h("span", {}, "Mã chat / @kênh"), chat),
      h("label", { class: "f" }, h("span", {}, "Báo khi bot ngoại tuyến quá (phút)"), offlineMin)),
    h("label", { class: "inline", title: "Bật để gửi thêm thông báo qua Email (SMTP) ngoài Telegram" }, smtpOn, "Gửi thêm qua Email (SMTP)"),
    smtpBox,
    result,
    h("div", { class: "row", style: "margin-top:8px" }, save, test)));
  void api<NotifyConfig>("GET", "/api/notify").then(fill).catch((e) => { status.textContent = `Không tải được cấu hình: ${errMsg(e)}`; status.className = "small err"; });
}

// Lịch phát lệnh: chuyển sang pages/lich-chay.ts (05/10/2026, N10) — trang riêng "Lịch chạy" + vẫn hiện ở Cài đặt.
